import React from "react";
import Style from "./ProductInfoAll.module.scss";
import { separate } from "../../../../../Utils/SeprateNumber/SeprateThreeNumber";
const ProductInfoAll = ({ data, statusId, Data }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div className={Style.orderInfo}>
        <p className={Style.id}>{"تصویر"}</p>
        <p className={Style.id}>{"آیدی"}</p>
        <p className={Style.food}>{"نام"}</p>
        <p className={Style.count}>{"مقدار"}</p>
        <p className={Style.price}>{"قیمت"}</p>
        <p className={Style.productFee}>{"کارمزد"}</p>
      </div>
      {data.products.map((element) => {
        return (
          <div key={element.product_id} className={Style.orderInfo}>
            <div className={Style.img}>
              <img
                src={`https://cdn.barest.ir/product/m/${element.product_id}.jpg`}
                alt=""
              />
            </div>
            <p className={Style.id}>{element.product_id}</p>
            <a
              href={`/editproduct/${element.product_id}`}
              rel="noreferrer"
              target="_blank"
              className={Style.food}
            >
              {element.name}
            </a>
            <p className={Style.count}>{element.count} عدد</p>
            <p className={Style.price}>
              {separate(element.price * element.count)}
              <span style={{ fontSize: ".7rem" }}>تومان</span>
            </p>
            <p className={Style.productFee}>
              {" "}
              {separate(element.product_fee * element.count)}
              <span style={{ fontSize: ".7rem" }}>تومان </span>
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default ProductInfoAll;
